import React, { useState, useEffect } from 'react'
import { Flex, Skeleton, Typography, Space, Divider, Avatar, Spin, Card, Button, Input } from 'antd'
import { getSale } from '../../services/bd/cardapioDigital'
import setaDireitaPNG from '../../img/abaixo-a-direita.png'
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications';
import '../../components/cupom/cupom.css'
import { Steps } from 'rsuite';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import SpinnerIcon from '@rsuite/icons/Spinner';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { socket } from '../../services/socketClient'
import { WhatsAppOutlined } from '@ant-design/icons';

const textColor = '#5b5b5b'

export const CupomCtrl = (props) => {


    const [venda, setVenda] = useState({})
    const [loading, setLoading] = useState(true)
    const { addToast } = useToasts()
    const app = props.app //useOutletContext();
    const { nome } = useParams()

    useEffect(() => {
        //  console.log('Loading cupom')
        loadSale()
    }, [])


    useEffect(() => {

        socket.on("connect", () => {
         //   console.log('connect delivery: ', props.saleid)
            socket.emit("joinRoomUID", 'delivery-'.concat(props.saleid))
        });


        socket.on("delivery-update", (msg) => {
        //    console.log("delivery-update", msg)
            loadSale()
        })

    //    console.log('Status socket: ', socket.connected)

        socket.connect()

        return () => {

           // console.log("Cobecteado: ", socket.connected)

            //  socket.off("disconnect")
          //  console.log('disconected')
            socket.off("delivery-update")
            socket.disconnect()
            socket.off("connect")

        }
    }, []);


    async function loadSale() {
        try {
            setLoading(true)
            const resp = await getSale({
                path: nome,
                salesid: props.saleid
            })
            setVenda(resp)
        //    console.log(resp)
        } catch (error) {
            addToast(error.message, {
                appearance: 'error',
                autoDismiss: true
            })
            // navigate(-1)
        }
        setLoading(false)
    }


    function renderStatus() {
        let hora1 = ""
        let hora2 = ''
        if (venda?.orderTiming === 'IMMEDIATE') {
            if (app?.entrega === '15-30min') {
                hora1 = dayjs(venda?.createAt).add(15, 'minutes').format('HH:mm')
                hora2 = dayjs(venda?.createAt).add(30, 'minutes').format('HH:mm')
            } else if (app?.entrega === '30-45min') {
                hora1 = dayjs(venda?.createAt).add(30, 'minutes').format('HH:mm')
                hora2 = dayjs(venda?.createAt).add(45, 'minutes').format('HH:mm')
            } else if (app?.entrega === '45-60min') {
                hora1 = dayjs(venda?.createAt).add(45, 'minutes').format('HH:mm')
                hora2 = dayjs(venda?.createAt).add(60, 'minutes').format('HH:mm')
            } else if (app?.entrega === '60-1h30min') {
                hora1 = dayjs(venda?.createAt).add(60, 'minutes').format('HH:mm')
                hora2 = dayjs(venda?.createAt).add(90, 'minutes').format('HH:mm')
            }
        }

        if (venda?.canceled === 1)
            return <Flex justify='center' align='center' gap={5}>
                <WarningRoundIcon style={{ fontSize: 15, color: 'red' }} />
                <Flex><b>CANCELADO:</b></Flex>
                <Flex>{venda?.cancelDescription}</Flex>
            </Flex>
        else if (venda?.code === 'CAN')
            return <Flex justify='center' align='center' gap={5}>
                <WarningRoundIcon style={{ fontSize: 15, color: 'red' }} />
                <Flex><b>CANCELADO:</b></Flex>
                <Flex>{venda?.cancelDescription}</Flex>
            </Flex>
        else if (venda.code === 'CFM') {
            return <Flex vertical>
                <Flex align='center'><b>Estabelecimento confirmou o pedido.</b></Flex>
                <Steps current={1} currentStatus={"process"}>
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<SpinnerIcon pulse />} />
                </Steps>
                <Flex align='center' gap={5}>
                    <Flex style={{ color: 'gray' }}>Previsão de entrega:</Flex>
                    <Flex><b>{hora1} - {hora2}</b></Flex>
                </Flex>
            </Flex>
        } else if (venda?.code === 'PLC') {
            return <Flex vertical>
                <Flex align='center'><b>Aguardando confirmação da loja</b></Flex>
                <Steps current={1} currentStatus={"process"}>
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<SpinnerIcon pulse />} />
                </Steps>
                <Flex align='center' gap={5}>
                    <Flex style={{ color: 'gray' }}>Previsão de entrega:</Flex>
                    <Flex><b>{hora1} - {hora2}</b></Flex>
                </Flex>
            </Flex>
        }
        else if (venda?.code === 'CFM') {
            return <Flex vertical>
                <Flex align='center'><b>Seu pedido está sendo preparado</b></Flex>
                <Steps current={1} currentStatus={"process"}>
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<SpinnerIcon pulse />} />
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                </Steps>
                <Flex align='center' gap={5}>
                    <Flex style={{ color: 'gray' }}>Previsão de entrega:</Flex>
                    <Flex><b>{hora1} - {hora2}</b></Flex>
                </Flex>
            </Flex>
        }
        else if (venda?.code === 'DSP') {
            return <Flex vertical>
                <Flex align='center'><b>Seu pedido saiu para entrega</b></Flex>
                <Steps current={1} currentStatus={"process"}>
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<SpinnerIcon pulse />} />
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                </Steps>
                <Flex align='center' gap={5}>
                    <Flex style={{ color: 'gray' }}>Previsão de entrega:</Flex>
                    <Flex><b>{hora1} - {hora2}</b></Flex>
                </Flex>
            </Flex>
        }
        else if (venda?.code === 'RTP') {
            return <Flex vertical>
                <Flex align='center'><b>{"Pronto para retirada"}</b></Flex>
                <Steps current={1} currentStatus={"process"}>
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<SpinnerIcon pulse />} />
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                </Steps>
                <Flex align='center' gap={5}>
                    <Flex style={{ color: 'gray' }}>Previsão de entrega:</Flex>
                    <Flex><b>{hora1} - {hora2}</b></Flex>
                </Flex>
            </Flex>
        }
        else if (venda?.code === 'DSP') {
            return <Flex vertical>
                <Flex align='center'><b>Seu pedido saiu para entrega</b></Flex>
                <Steps current={2} currentStatus={"process"}>
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                    <Steps.Item title="" icon={<SpinnerIcon pulse />} />
                    <Steps.Item title="" icon={<CheckOutlineIcon />} />
                </Steps>
                <Flex align='center' gap={5}>
                    <Flex style={{ color: 'gray' }}>Previsão de entrega:</Flex>
                    <Flex><b>{hora1} - {hora2}</b></Flex>
                </Flex>
            </Flex>
        }
        else if (venda?.code === 'CON') {
            return <Flex justify='center' align='center' gap={5}>
                <CheckOutlineIcon style={{ fontSize: 15 }} />
                <Flex align='center'><b>Pedido Entregue.</b></Flex>
            </Flex>
        }

    }


    function renderConfirmados() {

        if (loading)
            return <Flex vertical gap={8}>
                <Space
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    direction='horizontal'>
                    <Spin size="large" />
                    <Typography.Text style={{ color: 'royalblue' }}>Loading</Typography.Text>
                </Space>
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
                <Skeleton.Input active block size='small' />
            </Flex>

        return venda ? <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%', overflowY: 'auto' }}>
            {/*  return venda?.orders?.length > 0 ? <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%', overflowY: 'auto' }}> */}
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            <Card size='small' bordered>
                {
                    renderStatus()
                }
            </Card>


            <Card size='small' style={{ marginTop: 10 }}>
                {venda?.customerName && <Flex gap={5}>
                    <Flex style={{ fontWeight: 'bold' }}>Cliente: </Flex>
                    <Flex>{venda?.customerName}</Flex>
                </Flex>
                }
                {venda?.cliente?.phone && <Flex gap={5}>
                    <Flex style={{ fontWeight: 'bold' }}> Telefone: </Flex>
                    <Flex>{venda?.cliente?.phone}</Flex>
                </Flex>
                }
                {venda?.delivery && <Flex vertical style={{ fontWeight: 'bold', marginTop: 7, marginBottom: 10 }}>
                    <Flex gap={5}>
                        <Flex>{venda?.delivery?.endereco}
                            {venda?.delivery?.numero ? " nº ".concat(venda?.delivery?.numero, " ") : ' '}
                            {venda?.delivery?.complemento ? venda?.delivery?.complemento.concat(', ') : ', '}
                            {venda?.delivery?.cep}
                        </Flex>
                        <Flex> </Flex>
                        <Flex> </Flex>
                        <Flex> </Flex>
                    </Flex>
                    <Flex gap={5}>
                        <Flex> {"".concat(venda?.delivery.bairro, ",")} </Flex>
                        <Flex> {venda?.delivery.cidade} </Flex>
                        <Flex>/</Flex>
                        <Flex> {venda?.delivery.estado} </Flex>
                    </Flex>

                </Flex>
                }

            </Card>

            {
                venda.canceled === 0 && parseFloat(venda.aPagar) > 0 && venda.pagamentos[0].metodo === 'PIX' &&
                <Card size='small' style={{ marginTop: 10 }}>
                    <Flex vertical>
                        <Flex justify='center' gap={5} vertical align='center'>

                            <Flex style={{ fontSize: '1.2em', fontWeight: 'bold' }} align='center'>Pague pelo QRCode</Flex>
                            <Flex justify='center'> Pague até às {dayjs(venda.createAt).add(10, 'minutes').format('HH:mm:ss')} hs</Flex>
                            <img src={venda.pagamentos[0].qrcodeimage} height={200} width={200} alt='qrcode'></img>
                            <Input.TextArea value={venda.pagamentos[0].qrcode} autoSize style={{ width: '100%' }} />
                            <Flex align='center' gap={10} justify='center'>
                                <Button onClick={() => {
                                    navigator.clipboard.writeText(venda.pagamentos[0].qrcode)
                                        .then(() => {
                                            addToast('QRCode copiado!', {
                                                autoDismiss: true, appearance: 'info',
                                            })
                                        })
                                        .catch(err => {
                                            console.error("Erro ao copiar: ", err);
                                        });
                                }}>Clique para Copiar</Button>


                                <Button icon={<WhatsAppOutlined style={{ color: 'green' }} />} onClick={() => {
                                    // console.log(appref.current)
                                    // const fone = appref.current.whatshap.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "")
                                    // window.open('https://wa.me/55'.concat(fone, '?text=Segue comprovante do meu Pedido *', respPedido?.id, '*'), '_blank');
                                }}>Enviar comprovante</Button>

                            </Flex>

                        </Flex>
                    </Flex>
                </Card>
            }

            <Card size='small' style={{ marginTop: 10 }}>
                <div style={{ width: '100%', color: textColor }}>


                    <Flex flex={1} style={{ fontWeight: 'bold', minHeight: 16, height: 16, fontSize: '1em', width: '100%' }}>
                        <Flex style={{ width: '20%', textAlign: 'center' }} className="example-item example-item_first">Qtde</Flex>
                        <Flex flex={1} className="example-item example-item_second">Item</Flex>
                        <Flex style={{ width: '20%', textAlign: 'center', marginRight: 10 }} justify='flex-end' className="example-item example-item_third">Unit</Flex>
                        <Flex style={{ width: '20%', textAlign: 'right', marginRight: 15 }} className="example-item example-item_four" justify='flex-end'>Total</Flex>
                    </Flex>
                    <Divider style={{ marginTop: 5, marginBottom: 2 }} />

                    {venda?.orders && venda?.orders?.map((item, index) => {
                        return <div key={"order-data-user-".concat(item.idorder)}>
                            {
                                item.itens?.map((item2, index2) => {
                                    return <> <Flex className="example-cupom" key={'item-'.concat(item2.idorderItem)} style={{
                                        color: textColor,
                                        minHeight: 16, height: 16
                                    }}
                                    >
                                        <Flex style={{ width: '20%', textAlign: 'center' }} className="example-item example-item_first">{item2.quant}</Flex>
                                        <Flex flex={1} className="example-item example-item_second">{item2.itemDescricao}</Flex>
                                        <Flex style={{ width: '20%', textAlign: 'center', marginRight: 0 }} justify='flex-end' className="example-item example-item_third">{parseFloat(item2.valor).toFixed(2)}</Flex>
                                        <Flex style={{ width: '20%', textAlign: 'right' }} justify='flex-end' className="example-item example-item_four">
                                            {(item2.quant * item2.valor).toFixed(2)}
                                        </Flex>
                                    </Flex>

                                        {

                                            item2.groups?.map((gp, indexgp) => {
                                                return <Flex vertical key={"gp2".concat(indexgp)} style={{ width: '100%' }}>
                                                    <Flex style={{
                                                        fontSize: '1em', fontWeight: 600, marginLeft: 5, backgroundColor: 'whitesmoke', padding: 8,
                                                        paddingLeft: 15, marginBottom: 10
                                                    }}
                                                        gap={10} align='center'>

                                                    </Flex>
                                                    <Flex gap={2} style={{ width: '100%' }} vertical>
                                                        <Flex style={{ fontSize: '0.75em', fontStyle: 'italic', paddingLeft: 2, width: '100%' }}>{gp.name} </Flex>
                                                        {gp.itens?.map((gpi, indexgpi) => {
                                                            return <Flex vertical style={{ width: '100%', color: textColor }} key={"gp23-".concat(indexgpi)}>
                                                                <Flex style={{ fontSize: '0.9em', fontStyle: 'italic', paddingLeft: 2, width: '100%' }}  >
                                                                    <Flex style={{ width: '20%' }}>{parseFloat(gpi?.quant).toFixed(3)}</Flex>
                                                                    <Flex gap={10} vertical={false} align='center' style={{ color: textColor, width: '40%' }}>
                                                                        <Avatar height={5} size={12} src={setaDireitaPNG} />
                                                                        <Flex align='center' flex={1}>{gpi.itemDescricao} </Flex>
                                                                    </Flex>
                                                                    <Flex style={{ width: '20%' }} justify='right'> {parseFloat(gpi.valor).toFixed(2)}</Flex>
                                                                    <Flex style={{ width: '20%', paddingRight: 5 }} justify='right'> {(parseFloat(item2.quant) * parseFloat(gpi.valor) * parseFloat(gpi?.quant)).toFixed(2)}</Flex>

                                                                </Flex>
                                                                {
                                                                    gpi.items?.map((item4, i4) => {
                                                                        return <Flex key={"item4-".concat(i4)} style={{ fontSize: '0.9em', fontStyle: 'italic', paddingLeft: 2, width: '100%' }}  >
                                                                            <Flex style={{ width: '20%' }}>{parseFloat(item4?.quant).toFixed(3)}</Flex>
                                                                            <Flex gap={10} vertical={false} align='center' style={{ color: textColor, width: '40%' }}>

                                                                                <Flex align='center' flex={1} style={{ marginLeft: 35 }}>{item4.itemDescricao} </Flex>
                                                                            </Flex>
                                                                            <Flex style={{ width: '20%' }} justify='right'> {parseFloat(item4.valor).toFixed(2)}</Flex>
                                                                            <Flex style={{ width: '20%', paddingRight: 5 }} justify='right'> {(parseFloat(item2.quant) * parseFloat(item4.quant) * parseFloat(item4.valor) * parseFloat(gpi?.quant)).toFixed(2)}</Flex>

                                                                        </Flex>
                                                                    })
                                                                }
                                                            </Flex>


                                                        })
                                                        }
                                                    </Flex>
                                                </Flex>
                                            })
                                        }
                                        <Divider style={{ marginTop: 5, marginBottom: 2 }} />
                                    </>
                                })
                            }
                        </div>
                    })}



                </div>
                <Flex vertical style={{ width: '100%' }}>

                    {(parseFloat(venda?.produtos) > 0) &&
                        <Flex style={{ fontSize: '0.9em' }} align='center' justify='space-between' gap={2}>
                            <Flex > (+) produtos </Flex>
                            <Flex>R$ {(parseFloat(venda?.produtos)).toFixed(2)}</Flex>
                        </Flex>
                    }

                    {(parseFloat(venda?.servicos) > 0) &&
                        <Flex style={{ fontSize: '0.9em' }} align='center' justify='space-between' gap={2}>
                            <Flex > (+) servicos  </Flex>
                            <Flex>R$ {(parseFloat(venda?.servicos)).toFixed(2)}</Flex>
                        </Flex>
                    }

                    {(parseFloat(venda?.taxaEntrega) > 0) &&
                        <Flex style={{ fontSize: '0.9em' }} align='center' justify='space-between' gap={2}>
                            <Flex > (+) taxa entrega </Flex>
                            <Flex>R$ {(parseFloat(venda?.taxaEntrega)).toFixed(2)}</Flex>
                        </Flex>
                    }

                    {(parseFloat(venda?.couvert) > 0) &&
                        <Flex style={{ fontSize: '0.8em' }} align='center' justify='space-between' gap={2}>
                            <Flex > (+) couvert  </Flex>
                            <Flex>R$ {(parseFloat(venda?.couvert) * parseFloat(venda?.peoples)).toFixed(2)}</Flex>
                        </Flex>
                    }
                    {

                        (parseFloat(venda?.fidelidade) > 0) &&
                        <Flex style={{ fontSize: '0.8em' }} align='center' justify='space-between' gap={2}>
                            <Flex > (-) fidelidade  </Flex>
                            <Flex>R$ {(parseFloat(venda?.fidelidade)).toFixed(2)}</Flex>
                        </Flex>
                    }
                    <Flex justify='space-between'>
                        <Flex style={{ fontSize: '1.2em', fontWeight: 'bold' }} align='center'>TOTAL</Flex>
                        <Flex style={{ fontSize: '1.5em', fontWeight: 'bold' }} align='center' justify='right' gap={2}>
                            R$ {venda?.subtotal ? parseFloat(venda?.subtotal).toFixed(2) : '0,00'}
                        </Flex>

                    </Flex>
                    {
                        venda?.receitas?.length > 0 && <Divider style={{ marginTop: 2, marginBottom: 2 }} />
                    }
                    {
                        venda?.receitas?.map((receita, indexReceita) => {
                            return <Flex align='center' justify='space-between' gap={2}>
                                <Flex style={{ fontSize: '0.9em' }}> {receita.name}  </Flex>
                                <Flex>R$ {(parseFloat(receita?.changeFor)).toFixed(2)}</Flex>
                            </Flex>
                        })
                    }

                    <Flex align='center' justify='space-between' gap={2}>
                        <Flex style={{ fontSize: '0.9em' }}><b>Total pago</b></Flex>
                        <Flex><b>R$ {venda.totalPago}</b></Flex>
                    </Flex>

                    {

                        (parseFloat(venda?.aPagar) > 0) &&
                        <Flex align='center' justify='space-between' gap={2}>
                            <Flex > Falta  </Flex>
                            <Flex>R$ {(parseFloat(venda?.aPagar)).toFixed(2)}</Flex>
                        </Flex>
                    }

                    {

                        (parseFloat(venda?.troco) > 0) && <Flex align='center' justify='space-between' gap={2}>
                            <Flex style={{ fontSize: '0.9em' }}>Troco </Flex>
                            <Flex>R$ {venda.troco}</Flex>
                        </Flex>
                    }

                </Flex>
            </Card>


        </div> :
            <Flex align='center'
                justify='center' style={{ fontStyle: 'italic', color: textColor, fontSize: '0.85em' }}>
                Nenhum item adicionado
            </Flex>


    }



    return renderConfirmados()
}


export default CupomCtrl
